import React from "react"
import {observer} from "mobx-react"
import {FormattedMessage} from "react-intl"

import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import "../../global/ui/xsDialog/xsDialog.less"

import XsButton from "../../global/ui/xsButton/xsButton"

import CheckMedicineCardDialogStore from "./stores/CheckMedicineCardDialogStore"

@observer
export default class CheckMedicineCardDialog extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<Dialog
				aria-describedby="info-dialog-description"
				open={CheckMedicineCardDialogStore.isOpen}
				onEscapeKeyDown={() => CheckMedicineCardDialogStore.close()}
				maxWidth="md"
				className="xs-info-dialog"
			>
				<DialogTitle className="xs-info">
					<div className="xs-header">
						<div className="xs-header-icon">
							<i className="fal fa-info fa-2x" />
						</div>
						<div className="xs-header-title">{<FormattedMessage id="Common.form.info" />}</div>
					</div>
				</DialogTitle>
				<DialogContent className="xs-content">
					<FormattedMessage id="Common.label.clickToMedicineCard" />
				</DialogContent>
				<DialogActions className="xs-footer">
					<XsButton
						className="xs-info"
						text={<FormattedMessage id="Common.label.ok" />}
						onClick={() => CheckMedicineCardDialogStore.close()}
					/>
				</DialogActions>
			</Dialog>
		)
	}
}
